import { render, staticRenderFns } from "./notificationInfoIcon.vue?vue&type=template&id=3c9d4e54&"
import script from "./notificationInfoIcon.vue?vue&type=script&lang=js&"
export * from "./notificationInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports